import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fetchTransactionsService,
  forgotPasswordService,
  resetPasswordService,
  sendEmailOTPService,
} from "../../services";
import { HttpApiClient } from "../../axios/axiosInstance";

const initialState = {
  userName: null,
  userType: null,
  isAuthenticated: false,
  transactions: null,
};

export const fetchTransactions = createAsyncThunk(
  "booking/fetchTransactions",
  async (request) => {
    const response = await HttpApiClient.get(fetchTransactionsService);
    return response.data.data;
  }
);

export const forgotPassword = createAsyncThunk(
  "user/forgotPassword",
  async (request) => {
    const response = await HttpApiClient.post(forgotPasswordService, request);
    return response.data;
  }
);

export const resetPassword = createAsyncThunk(
  "user/resetPassword",
  async (request) => {
    const response = await HttpApiClient.post(
      `${resetPasswordService}`,
      request
    );
    return response.data;
  }
);

export const sendEmailOTP = createAsyncThunk(
  "user/sendEmailOTP",
  async (request) => {
    const response = await HttpApiClient.post(
      `${sendEmailOTPService}`,
      request
    );
    return response.data;
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.userName = action.payload.userName;
      state.userType = action.payload.userType;
    },
    clearUser: (state) => {
      state.userName = "";
      state.userType = "";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTransactions.fulfilled, (state, action) => {
      state.transactions = action.payload;
    });
  },
});

export const { setUser, clearUser } = userSlice.actions;
export default userSlice.reducer;
